import { render, staticRenderFns } from "./member-widget.vue?vue&type=template&id=3dc69e16&"
import script from "./member-widget.vue?vue&type=script&lang=js&"
export * from "./member-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports